import React from 'react'
import { observer } from 'mobx-react-lite'
import Input from '../../../../../../../../components/FormComponents/Input'

export default observer(function YoutubeInsightForm({ formProps }) {
  const { handleBlur, handleChange, values, touched, errors } = formProps
  
  return (
    <div className='flex flex-col gap-2'>
      <div className="grid grid-cols-2 gap-2">
        <div>
          <Input 
            overrideClassName="pl-4 h-8" 
            topMargin={false} 
            error={touched.reach && errors.reach} 
            noLabelPadding 
            label="Reach" 
            placeholder="Reach" 
            name='reach' 
            onChange={handleChange} 
            onBlur={handleBlur} 
            value={values.reach} 
          />
        </div>
        <div>
          <Input 
            overrideClassName="pl-4 h-8" 
            topMargin={false} 
            error={touched.impressions && errors.impressions} 
            noLabelPadding 
            label="Impressions" 
            placeholder="Impressions" 
            name='impressions' 
            onChange={handleChange} 
            onBlur={handleBlur} 
            value={values.impressions} 
          />
        </div>
        <div>
          <Input 
            overrideClassName="pl-4 h-8" 
            topMargin={false} 
            error={touched.views && errors.views} 
            noLabelPadding 
            label="Views" 
            placeholder="Views" 
            name='views' 
            onChange={handleChange} 
            onBlur={handleBlur} 
            value={values.views} 
          />
        </div>
        <div>
          <Input 
            overrideClassName="pl-4 h-8" 
            topMargin={false} 
            error={touched.likes && errors.likes} 
            noLabelPadding 
            label="Likes" 
            placeholder="Likes" 
            name='likes' 
            onChange={handleChange} 
            onBlur={handleBlur} 
            value={values.likes} 
          />
        </div>
        <div>
          <Input 
            overrideClassName="pl-4 h-8" 
            topMargin={false} 
            error={touched.comments && errors.comments} 
            noLabelPadding 
            label="Comments" 
            placeholder="Comments" 
            name='comments' 
            onChange={handleChange} 
            onBlur={handleBlur} 
            value={values.comments} 
          />
        </div>
        <div>
          <Input 
            overrideClassName="pl-4 h-8" 
            topMargin={false} 
            error={touched.reel_duration && errors.reel_duration} 
            noLabelPadding 
            label="Video Duration" 
            placeholder="Video Duration" 
            name='reel_duration' 
            onChange={handleChange} 
            onBlur={handleBlur} 
            value={values.reel_duration} 
          />
        </div>
        <div>
          <Input 
            overrideClassName="pl-4 h-8" 
            topMargin={false} 
            error={touched.watchtime && errors.watchtime} 
            noLabelPadding 
            label="Watchtime" 
            placeholder="Watchtime" 
            name='watchtime' 
            onChange={handleChange} 
            onBlur={handleBlur} 
            value={values.watchtime} 
          />
        </div>
        <div>
          <Input 
            overrideClassName="pl-4 h-8" 
            topMargin={false} 
            error={touched.in_country_views_percentage && errors.in_country_views_percentage} 
            noLabelPadding 
            addon="%"
            addonPosition="end"
            label="In Country Views %" 
            placeholder="In Country Views" 
            name='in_country_views_percentage' 
            onChange={handleChange} 
            onBlur={handleBlur} 
            value={values.in_country_views_percentage} 
          />
        </div>
        <div>
          <Input 
            overrideClassName="pl-4 h-8" 
            topMargin={false} 
            addon="%"
            addonPosition="end"
            error={touched.female_views_percentage && errors.female_views_percentage} 
            noLabelPadding 
            label="Female Views %" 
            placeholder="Female Views" 
            name='female_views_percentage' 
            onChange={handleChange} 
            onBlur={handleBlur} 
            value={values.female_views_percentage} 
          />
        </div>
        <div>
          <Input 
            overrideClassName="pl-4 h-8" 
            topMargin={false} 
            addon="%"
            addonPosition="end"
            error={touched.male_views_percentage && errors.male_views_percentage} 
            noLabelPadding 
            label="Male Views %" 
            placeholder="Male Views" 
            name='male_views_percentage' 
            onChange={handleChange} 
            onBlur={handleBlur} 
            value={values.male_views_percentage} 
          />
        </div>
      </div>
    </div>
  )
})
